.wrapper {
    height: 100%;
    display: flex;
    flex-direction: column;
}

.left-section {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: var(--plum-bg);
}

.main-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 32px;
    width: 100%;
    padding: 24px;
    box-sizing: border-box;
    overflow: auto;
}

.footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px;
}

.pill {
    position: absolute;
    top: -16px;
}
